export enum BillingFrequencyIntervals {
  WEEK = "week",
  MONTH = "month",
  YEAR = "year",
}

export const BILLING_FREQUENCIES = [
  {
    id: "week",
    label: "Weekly",
    onlineStoreLabel: "week",
    billingFrequency: BillingFrequencyIntervals.WEEK,
    billingFrequencyCount: 1,
  },
  {
    id: "month",
    label: "Monthly",
    onlineStoreLabel: "month",
    billingFrequency: BillingFrequencyIntervals.MONTH,
    billingFrequencyCount: 1,
  },
  {
    id: "quarter",
    label: "Quarterly",
    onlineStoreLabel: "3 months",
    billingFrequency: BillingFrequencyIntervals.MONTH,
    billingFrequencyCount: 3,
  },
  {
    id: "semi-annually",
    label: "Semi-annually",
    onlineStoreLabel: "6 months",
    billingFrequency: BillingFrequencyIntervals.MONTH,
    billingFrequencyCount: 6,
  },
  {
    id: "annually",
    label: "Annually",
    onlineStoreLabel: "year",
    billingFrequency: BillingFrequencyIntervals.YEAR,
    billingFrequencyCount: 1,
  },
];

export type BillingFrequency = (typeof BILLING_FREQUENCIES)[number];

export function getBillingFrequencyFromInterval(
  billingInterval: BillingFrequencyIntervals,
  billingIntervalCount: number
): BillingFrequency {
  return BILLING_FREQUENCIES.find(
    (frequency) =>
      frequency.billingFrequency === billingInterval &&
      frequency.billingFrequencyCount === billingIntervalCount
  );
}
